"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Piece = Piece;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const TraitIcon_1 = require("~/components/ui/TraitIcon");
const creatureImage_1 = require("../../../ui/creatureImage");
const PieceHealthbar_1 = require("./meta/PieceHealthbar");
const useStyles = (0, react_jss_1.createUseStyles)({
    piece: {
        "position": "relative",
        "width": "100%",
        "height": "100%",
        "& > img": {
            position: "absolute",
            bottom: 0,
            right: 0,
            width: "80%",
        },
        "containerName": "piece",
        "containerType": "size",
    },
    imageContainer: {
        position: "absolute",
        bottom: "0",
        left: "14%",
        width: "80%",
        height: "80%",
    },
    healthbarContainer: {
        "position": "absolute",
        "top": "4%",
        "left": "4%",
        "height": "10%",
        "width": "70%",
        "@container piece (max-width: 64px)": {
            height: "18%",
            width: "66%",
        },
    },
    traits: {
        "display": "flex",
        "flexDirection": "column",
        "gap": "2px",
        "position": "absolute",
        "top": "4%",
        "right": "4%",
        "background": "rgb(49 54 56 / 50%)",
        "width": "16%",
        "padding": "2px",
        "@container piece (max-width: 64px)": {
            width: "14%",
        },
    },
    stage: {
        display: "flex",
        flexDirection: "row",
        gap: "2px",
        position: "absolute",
        bottom: "4%",
        right: "4%",
        background: "rgb(49 54 56 / 50%)",
        height: "14%",
        padding: "2px",
    },
});
function Piece({ piece, healthbar, facing = "front", className, children, onClick, }) {
    const classes = useStyles();
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.piece, className), onClick: onClick },
        React.createElement("div", { className: classes.healthbarContainer }, healthbar && (React.createElement(PieceHealthbar_1.PieceHealthbar, { color: healthbar.color, current: healthbar.current, max: piece.maxHealth }))),
        React.createElement("div", { className: classes.imageContainer },
            React.createElement(creatureImage_1.CreatureImage, { definitionId: piece.definitionId, facing: facing === "back" ? "back" : "front" })),
        piece.stage > 0 && (React.createElement("div", { className: classes.stage }, Array.from({ length: piece.stage + 1 }, (_, i) => (React.createElement("img", { key: i, src: `${APP_IMAGE_ROOT}/ui/star.svg` }))))),
        piece.traits.length > 0 && (React.createElement("div", { className: classes.traits }, piece.traits.map((trait) => (React.createElement("img", { key: trait, src: TraitIcon_1.ICON_FOR_TRAIT[trait], alt: `${trait} trait` }))))),
        children));
}
